<template>
	<CRow>
		<CModal :title="
			submitType === 'Update'
			? $lang.reviewTag.crud.edit
			: $lang.reviewTag.crud.create" size="lg" :show.sync="largeModal" :no-close-on-backdrop="true"
			color="primary">
			<CAlert :color="messageColorModal" closeButton :show.sync="dismissCountDownModal" fade>{{ err_msg }}
			</CAlert>
			<CForm novalidate @submit.prevent="onSubmit">
				<CCardBody>
					<CRow class="align-items-start">
						<CCol>
							<div class="form-group">
								<label class="form__label">
									{{ $lang.reviewTag.form.title }}
								</label>
								<input type="text" :placeholder="$lang.reviewTag.form.title" class="form-control"
									v-model="reviewTag.title" />
							</div>
						</CCol>
					</CRow>
					<CRow class="align-items-start">
						<CCol>
							<div class="form-group">
								<label class="form__label">&nbsp;</label>
								<CButton type="submit" size="sm" color="primary">
									<CIcon name="cil-check-circle" />
									{{ $lang.buttons.general.crud.submit }}
								</CButton>
							</div>
						</CCol>
					</CRow>
				</CCardBody>
			</CForm>
			<template #footer style="display: none;padding: 0px;border-top: 0px solid;">
				<div> </div>
			</template>
		</CModal>
		<CCol col="12">
			<CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>{{ err_msg }} </CAlert>
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>Review Tags</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
								<CButton color="primary" v-on:click="createTableRow()"
									v-if="checkPermission('create-review-tag')" style="margin-right: 10px">
									{{ $lang.buttons.general.crud.create }}
								</CButton>
								<CButtonGroup class="file-export">
									<CButton color="secondary" disabled>
										{{ $lang.buttons.export.title }}
									</CButton>
									<CButton color="danger" v-c-tooltip="$lang.buttons.export.pdf"
										v-on:click="exports(self, 'pdf', module, 'review-tag')">
										<i class="fas fa-file-pdf"></i>
									</CButton>
									<VueJsonToCsv class="btn btn-success" v-c-tooltip="$lang.buttons.export.excel"
										:json-data="json_data" :labels="json_label" :csv-title="json_title">
										<i class="fas fa-file-excel"></i>
									</VueJsonToCsv>
									<CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.view"
                                        v-if="checkPermission('other-review-tag')"
										v-on:click="NewSkillList()">
										New Review Tags
									</CButton>
								</CButtonGroup>
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
					<v-server-table :key="tableKey" :url="module.api.list" :columns="columns" :options="options"
						ref="myTable" :data="data" @loaded="onDataLoaded">
						<template #actions="data">
							<CButton color="success" v-c-tooltip="$lang.buttons.general.crud.edit"
								v-on:click="editTableRow(data.row.id)" v-if="checkPermission('edit-review-tag')">
								<i class="fas fa-pencil-alt"></i>
							</CButton>
							<CButton color="danger" v-c-tooltip="$lang.buttons.general.crud.delete"
								v-on:click="deletePopup(data.row.id)" v-if="checkPermission('delete-review-tag')">
								<i class="fas fa-trash"></i>
							</CButton>
						</template>
					</v-server-table>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { ReviewTag } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
import store from "@/store/store";
import required_span from "../../components/layouts/general/required-span";
import { minLength, required } from "vuelidate/lib/validators";
import { Maxlength } from "../../store/maxlength";
Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
	name: "ReviewTag",
	mixins: [Mixin],
	components: {
		VueJsonToCsv,
		required_span,
	},
	data() {
		return {
			messageColor: "success",
			messageColorModal: "danger",
			err_msg: "",
			alertMessage: "",
			showAlert: false,
			dismissCountDownModal: 0,
			dismissCountDown: 0,
			dismissCountDownS: 0,
			self: this,
			activePage: 1,
			submitType: "",
			module: ReviewTag,
			json_data: [],
			json_label: {},
			json_title: "",
			tableKey: 0, // Add a key to force table reload
			data: [],
			largeModal: false,
			submitted: false,
			editId: "",
			reviewTag: {
				id: "",
				title: ""
			},
			maxlength: {
				title: Maxlength.tags.title,
			},
			columns: [
				this.$lang.reviewTag.table.columns.title,
				this.$lang.reviewTag.table.columns.actions,
			],
			options: {
				headings: {
					title: this.$lang.reviewTag.table.title,
					actions: this.$lang.reviewTag.table.actions,
				},
				sortable: [this.$lang.reviewTag.table.createdAt, this.$lang.reviewTag.table.isActive],
				filterable: [this.$lang.reviewTag.table.createdAt],
				perPage: 50,
			},
		};
	},
	mounted() {
		let self = this;
		store.commit("showLoader", false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
	methods: {
		NewSkillList(item, index) {
			this.$router.push({ path: `review-tag/other` });
		},
		setAlert(value) {
			this.showAlert = value;
		},
		pageChange(val) {
			this.$router.push({ query: { page: val } });
		},
		onDataLoaded(data) {
			// console.log("data.data.data",data.data.data);
		},
		createTableRow() {
			let self = this;
			// self.$v.$reset();
			self.submitType = "Create";
			self.reviewTag.title = "";
			self.largeModal = true;
		},
		deletePopup(item) {
			this.$swal({
				title: this.$lang.common.delete_swal.are_you,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#e55353",
				confirmButtonText: this.$lang.common.delete_swal.yes_delete,
				cancelButtonText: this.$lang.common.delete_swal.cancel,
			}).then((result) => {
				if (result.value) {
					let self = this;
					axios
						.delete(this.deleteUrlApi(this.module, item), self)
						.then(function (response) {
							if (response.data.status === 200) {
								self.$refs.myTable.refresh();
								self.err_msg = response.data.message;
								self.messageColor = "success";
								self.dismissCountDown = 10;
							} else {
								self.$refs.myTable.refresh();
								self.alertMessage = response.data.message;
								self.messageColor = "danger";
								self.dismissCountDown = 10;
							}
						}).catch(function (error) {
							let data;
							if (error.response.data.error) {
								data = error.response.data.error.toString();
							} else {
								data = error.response.data.message;
							}
							self.$refs.myTable.refresh();
							self.err_msg = data;
							self.messageColor = "danger";
							self.dismissCountDown = 10;
						});
				}
			});
		},
		editTableRow(item) {
			let self = this;
			const id = item;
			self.editId = item;
			self.submitType = "Update";
			axios
				.get(self.viewUrlApi(self.module, id), self.model)
				.then(function (response) {
					if (response) {
						const responseData = response.data.data;
						self.reviewTag.id = responseData.id;
						self.reviewTag.title = responseData.title;
					} else {
						self.data = [];
					}
				});
			self.largeModal = true;
		},
		onSubmit() {
			let self = this;
			// this.$v.reviewTag.$touch();
			self.submitted = true; //Disable Button
			this.submitStatus = "PENDING";
			if (this.submitType === "Update") {
				setTimeout(() => {
					let self = this;
					const postData = {
						title: self.reviewTag.title,
					};
					axios
						.post(this.editUrlApi(this.module, self.editId), postData)
						.then(function (response) {
							self.submitted = false; //Enable Button
							if (response.data.code === 200) {
								self.largeModal = false;
								self.$refs.myTable.refresh();
								self.alertMessage = response.data.message;
								self.messageColor = "success";
								self.dismissCountDownS = 10;
							} else {
								self.messageColorModal = "danger";
								self.err_msg = response.data.message;
								self.dismissCountDownModal = 10;
							}
						})
						.catch(function (error) {
							if (error.response.data.error) {
								var data = error.response.data.error.toString();
							} else {
								var data = error.response.data.message;
							}
							self.messageColorModal = "danger";
							self.err_msg = data;
							self.dismissCountDownModal = 10;
							self.submitted = false; //Enable Button
						});
				}, 500);
			} else {
				setTimeout(() => {
					let self = this;
					const postData = {
						title: self.reviewTag.title
					};
					axios
						.post(self.createUrlApi(self.module), postData)
						.then(function (response) {
							self.submitted = false; //Enable Button
							if (response.data.code === 200) {
								self.largeModal = false;
								self.$refs.myTable.refresh();
								self.messageColor = "success";
								self.err_msg = response.data.message;
								self.dismissCountDown = 10;
							} else {
								self.messageColorModal = "danger";
								self.err_msg = response.data.message;
								self.dismissCountDownModal = 10;
							}
						})
						.catch(function (error) {
							if (error.response.data.error) {
								var data = error.response.data.error.toString();
							} else {
								var data = error.response.data.message;
							}
							self.messageColorModal = "danger";
							self.err_msg = data;
							self.dismissCountDownModal = 10;
							self.submitted = false; //Enable Button
						});
				}, 500);
			}
		},
		onSubmitold() {
			let self = this;
			const editId = self.reviewTag.id;
			setTimeout(() => {
				const postData = {
					title: self.reviewTag.title
				};

				axios
					.post(self.editUrlApi(self.module, editId), postData)
					.then(function (response) {
						self.submitted = false; //Enable Button

						if (response.data.code === 200) {
							self.largeModal = false;
							self.$refs.myTable.refresh();
							self.messageColor = "success";
							self.err_msg = response.data.message;
							self.dismissCountDown = 10;

						} else {
							self.messageColorModal = "danger";
							self.err_msg = response.data.message;
							self.dismissCountDownModal = 10;
						}
					})
					.catch(function (error) {
						if (error.response.data.error) {
							var data = error.response.data.error.toString();
						} else {
							var data = error.response.data.message;
						}
						self.messageColorModal = "danger";
						self.err_msg = data;
						self.dismissCountDownModal = 10;
						self.submitted = false; //Enable Button
					});
			}, 500);
		}
	},
};
</script>
